import d from "../../../@babel/runtime/helpers/esm/typeof2.mjs";
var u = 8, v = 3, s = 16, T = function(r) {
  var t = {
    offset: u,
    threshold: v,
    gap: s
  };
  if (r && d(r) === "object") {
    var a, e, l;
    t.offset = (a = r.offset) !== null && a !== void 0 ? a : u, t.threshold = (e = r.threshold) !== null && e !== void 0 ? e : v, t.gap = (l = r.gap) !== null && l !== void 0 ? l : s;
  }
  return [!!r, t];
};
export {
  T as default
};
//# sourceMappingURL=useStack.mjs.map
